import { memo, useEffect, useRef } from 'react'

import { useQuery } from '@tanstack/react-query'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'

import { Editor, EditorInstance } from '@shared/components/Editor'
import { LoadingIndicator } from '@shared/layouts'
import { useEventUpdateMutation } from 'hooks/mutations/smep'
import { PageError } from 'layouts'
import { eventConfigRoute } from 'pages/NWPlatform/Workspaces/Workspace/Events/Event'
import { eventQueryKeys } from 'services/queryKeys'

const JSONConfigRaw = () => {
  const { t } = useTranslation(['domain'])
  const { enqueueSnackbar } = useSnackbar()

  const editorInstanceRef = useRef<EditorInstance>(undefined)

  const { eventId } = eventConfigRoute.useParams()

  const eventQuery = useQuery({
    ...eventQueryKeys.detail({ eventId }),
  })

  const { mutate } = useEventUpdateMutation()

  useEffect(() => {
    if (editorInstanceRef.current && eventQuery.isSuccess) {
      editorInstanceRef.current.getModel()?.setValue(window.JSON.stringify(eventQuery.data.config, null, 4))
    }
  }, [eventQuery])

  if (eventQuery.isLoading) {
    return <LoadingIndicator />
  }

  if (eventQuery.isSuccess) {
    return (
      <Editor
        value={eventQuery.data.config}
        onSubmit={(data) => {
          mutate(
            {
              eventId: eventId,
              smepEventEdit: { config: data },
            },
            {
              onSuccess: (data) => {
                enqueueSnackbar(t('Workspace.Event.eventConfigUpdated', { name: data.name }), {
                  variant: 'success',
                })
              },
            },
          )
        }}
        getEditorInstance={(editorInstance: EditorInstance) => void (editorInstanceRef.current = editorInstance)}
      />
    )
  }

  return <PageError />
}

export const JSONConfig = memo(JSONConfigRaw)
